import { combineEpics } from 'redux-observable'
import DefaultEpics from 'epics/defaultEpics'
import { fetchFollowEpic, updateFollowEpic } from 'epics/user/follow'
export default combineEpics(...DefaultEpics, fetchFollowEpic, updateFollowEpic)